export default __webpack_public_path__ + "static/media/Ellipse.5020bdcd.svg";